export function getFrom(list) {
  return list.map(item => ({ id: item._id, text: item.name }))
}
